module.exports = __webpack_public_path__ + "static/media/loadingBook.6304441b.gif";